import type { IController } from 'angular';
import type { PrintingService } from '../../Print/printing.service';
import type { ExportConfig } from '../../Print/export-dialog/export-dialog.component';
import type { DashboardFiltersValues } from '../dashboard-filters.service';

import template from './dashboard-export-base64.component.html';

export interface DashboardData {
	title: string;
	navigationId: string;
	filters: DashboardFiltersValues;
}

export class DashboardExportBase64Controller implements IController {
	downloading = false;
	config?: ExportConfig;
	base64 = '';
	fnRef: () => Promise<string | void> = async () => {};
	dashboardData!: DashboardData;

	static readonly $inject = ['mx.sb.Printing.PrintingService'];

	constructor(private readonly printingService: PrintingService) {}

	$onInit() {
		this.fnRef = async () => {
			if (!this.config) {
				return;
			}
			switch (this.config.type) {
				case 'pdf':
					this.base64 = await this.printingService.getPdfAsBase64(this.config.contentNode, this.config.orientation, this.config.headerNode, this.config.footerNode);
					return this.base64;
				case 'png':
				case 'jpeg':
					this.base64 = await this.printingService.getImageAsBase64(this.config.contentNode, this.config.headerNode, this.config.footerNode, this.config.type);
					return this.base64;
			}
		};
	}

	handleConfigChange(config: ExportConfig) {
		this.config = config;
	}
}

export const DashboardExportBase64Component = {
	name: 'mxDashboardExportBase64',
	controllerAs: 'vm',
	controller: DashboardExportBase64Controller,
	bindings: {
		fnRef: '=?value',
		base64: '=?value2',
		dashboardData: '=?value3',
	},
	template,
};
